export default {
  id: null,
  companyID: null,
  name: null,
  cpfCnpj: null,
  rg: null,
  cnh: null,
  address: null,
  number: null,
  complement: null,
  district: null,
  zipcode: null,
  stateID: null,
  cityID: null,
  phone: null,
  cellPhone: null,
  email: false,
  status: true,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/common/insuredmodel.js